import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';

const HelpTextModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="What is considered as rebuilding costs?"
    isOpen={isOpen}
    onClose={onClose}
  >
    <Text>
      It is for building only not including land value or contents. Includes
      outbuildings, internal fittings and fixtures such as kitchen cupboards,
      light fittings, floor tiles and structural improvements such as an
      in-ground swimming pool, pergolas, decks, fences and tennis courts.
    </Text>
  </Modal>
);

export default HelpTextModal;
